import { render, staticRenderFns } from "./admin-menu-lg.vue?vue&type=template&id=3e63950c&scoped=true&"
import script from "./admin-menu-lg.vue?vue&type=script&lang=js&"
export * from "./admin-menu-lg.vue?vue&type=script&lang=js&"
import style0 from "./admin-menu-lg.vue?vue&type=style&index=0&id=3e63950c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63950c",
  null
  
)

export default component.exports